export default __webpack_public_path__ + "static/media/3.313b236b.svg";